import { ImportDocument } from "../documents"

export const allowedTypes = [".jpg", ".jpeg", ".png", ".gif", ".pdf"]

export interface ISize {
    name: string
    id: string
}

export interface IDocumentLibraryArguments {
    selection?: boolean
    multipleSelection?: boolean
    manageLibrary?: boolean
    title?: string
    limitToPictures: boolean
}

export interface ImportDocumentVm {

    selected: boolean
    document: ImportDocument

}
